import { render, staticRenderFns } from "./AllReservationsTable.vue?vue&type=template&id=1c536916&scoped=true&"
import script from "./AllReservationsTable.vue?vue&type=script&lang=js&"
export * from "./AllReservationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllReservationsTable.vue?vue&type=style&index=0&id=1c536916&lang=scss&scoped=true&"
import style1 from "./AllReservationsTable.vue?vue&type=style&index=1&id=1c536916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c536916",
  null
  
)

export default component.exports